export const QA_Custom = [
  {
    domainName: "accentcaredirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "AccentCare Direct Messaging",
      layout_subpage_title: "- AccentCare - Direct Mail",
    },
  },
  {
    domainName: "allmedsccd.com",
    data: {
      "data-domain-name": "",
      layout_title: "AllMeds Direct Messaging",
      layout_subpage_title: "- AllMeds - Direct Mail",
    },
  },
  {
    domainName: "centerwellhomehealthdirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "CenterWell Home Health Direct Messaging",
      layout_subpage_title: "- CenterWell Home Health - Direct Mail",
    },
  },
  {
    domainName: "direct.c3hie.org",
    data: {
      "data-domain-name": "",
      layout_title: "C3 HIE Direct Messaging",
      layout_subpage_title: "- C3 HIE - Direct Mail",
    },
  },
  {
    domainName: "direct.consent2share.org",
    data: {
      "data-domain-name": "",
      layout_title: "FEI Systems Direct Messaging",
      layout_subpage_title: "- FEI Systems - Direct Mail",
      acr_values: "idp:consent2share",
    },
  },
  {
    domainName: "direct.alohr.alabama.gov",
    data: {
      "data-domain-name": "",
      layout_title: "ALOHR Direct Messaging",
      layout_subpage_title: "- ALOHR - Direct Mail",
    },
  },
  {
    domainName: "direct.c3hie.org",
    data: {
      "data-domain-name": "",
      layout_title: "C3 HIE Direct Messaging",
      layout_subpage_title: "- C3 HIE - Direct Mail",
    },
  },
  {
    domainName: "direct.nmhcare.org",
    data: {
      "data-domain-name": "",
      layout_title: "Northern Montana Health Care Direct Messaging",
      layout_subpage_title: "- NMHC - Direct Mail",
    },
  },
  {
    domainName: "direct.messaging.carbonhealth.com",
    data: {
      "data-domain-name": "",
      layout_title: "Carbon Health Direct Messaging",
      layout_subpage_title: "- Carbon Health - Direct Mail",
    },
  },
  {
    domainName: "ext.upmcdirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "UPMC Direct Messaging",
      layout_subpage_title: "- UPMC - Direct Mail",
      auth_cookie_timeout: "30",
      "tfa-enabled": "true",
    },
  },

  {
    domainName: "hddsmadmin.nchealthconnex.net",
    data: {
      "data-domain-name": "",
      layout_title: "NC HealthConnex Direct Messaging",
      layout_subpage_title: "- NC HealthConnex - Direct Mail",
    },
  },
  {
    domainName: "hhc.pccdm.com",
    data: {
      "data-domain-name": "",
      layout_title: "Point Click Care Direct Messaging",
      layout_subpage_title: "- Point Click Care - Direct Mail",
    },
  },
  {
    domainName: "dsmadmin.nchealthconnex.net",
    data: {
      "data-domain-name": "",
      layout_title: "NC HealthConnex Direct Messaging",
      layout_subpage_title: "- NC HealthConnex - Direct Mail",
    },
  },
  {
    domainName: "cadirect.org",
    data: {
      "data-domain-name": "",
      layout_title: "California Direct",
      layout_subpage_title: "- California Direct - Direct Mail",
    },
  },
  {
    domainName: "carealigndirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "SSI Direct Messaging",
      layout_subpage_title: "- SSI - Direct Mail",
    },
  },
  {
    domainName: "cchiedirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "Clinical Connect Direct Messaging",
      layout_subpage_title: "- Clinical Connect - Direct Mail",
    },
  },
  {
    domainName: "crispdirect.org",
    data: {
      "data-domain-name": "",
      layout_title: "CRISP Direct Messaging",
      layout_subpage_title: "- CRISP - Direct Mail",
      auth_cookie_timeout: "30",
      "tfa-enabled": "true",
    },
  },
  {
    domainName: "ctproviderdirect.org",
    data: {
      "data-domain-name": "",
      layout_title: "CT Provider Direct Messaging",
      layout_subpage_title: "- CT Provider - Direct Mail",
      auth_cookie_timeout: "30",
      "tfa-enabled": "true",
    },
  },
  {
    domainName: "navihealthconnect.com",
    data: {
      "data-domain-name": "",
      layout_title: "naviHealth Direct Messaging",
      layout_subpage_title: "- naviHealth - Direct Mail",
    },
  },
  {
    domainName: "nehiidirectmail.org",
    data: {
      "data-domain-name": "",
      layout_title: "NEHII Direct Messaging",
      layout_subpage_title: "- NEHII - Direct Mail",
    },
  },
  {
    domainName: "direct.centene.com",
    data: {
      "data-domain-name": "direct.centene.com",
      layout_title: "Centene Direct Messaging ",
      layout_subpage_title: "- Centene-Direct Mail",
    },
  },
  {
    domainName: "direct.consensussignal.com",
    data: {
      "data-domain-name": "",
      layout_title: "Consensus Signal Direct Messaging",
      layout_subpage_title: "- Consensus Signal - Direct Mail",
    },
  },
  {
    domainName: "direct.ehana.com",
    data: {
      "data-domain-name": "",
      layout_title: "eHana Direct Messaging",
      layout_subpage_title: "- eHana - Direct Mail",
    },
  },
  {
    domainName: "direct.idahohde.org",
    data: {
      "data-domain-name": "",
      layout_title: "IHDE Direct Messaging",
      layout_subpage_title: "- IHDE - Direct Mail",
    },
  },
  {
    domainName: "direct.la-hie.org",
    data: {
      "data-domain-name": "",
      layout_title: "Louisiana Health Information Exchange Direct Messaging",
      layout_subpage_title:
        "- Louisiana Health Information Exchange - Direct Mail",
    },
  },
  {
    domainName: "direct.medfusion.com",
    data: {
      "data-domain-name": "",
      layout_title: "MedFusion Direct Messaging",
      layout_subpage_title: "- MedFusion - Direct Mail",
    },
  },
  {
    domainName: "direct.mtbscc.org",
    data: {
      "data-domain-name": "",
      layout_title: "BSCC Direct Messaging",
      layout_subpage_title: "- BSCC - Direct Mail",
    },
  },
  {
    domainName: "direct.mhhcc.org",
    data: {
      "data-domain-name": "",
      layout_title: "Memorial Hospital Direct Messaging",
      layout_subpage_title: "- Memorial Hospital - Direct Mail",
    },
  },
  {
    domainName: "direct.nrh-ok.com",
    data: {
      "data-domain-name": "",
      layout_title: "Norman Regional Health System Direct Messaging",
      layout_subpage_title: "- Norman Regional Health System - Direct Mail",
    },
  },
  {
    domainName: "direct.ocprhio.org",
    data: {
      "data-domain-name": "",
      layout_title: "OC PRHIO Direct Messaging",
      layout_subpage_title: "- OC PRHIO - Direct Mail",
    },
  },
  {
    domainName: "direct.ocuhub.com",
    data: {
      "data-domain-name": "",
      layout_title: "OcuHUb Direct Messaging",
      layout_subpage_title: "- OcuHUb - Direct Mail",
      acr_values: "idp:OpenIdConnect",
    },
  },
  {
    domainName: "pwnhealthdirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "PWN Health Direct Messaging",
      layout_subpage_title: "- PWN Health - Direct Mail",
    },
  },
  {
    domainName: "direct.sceha.org",
    data: {
      "data-domain-name": "",
      layout_title: "SCeHA Direct Messaging",
      layout_subpage_title: "- DCeHA - Direct Mail",
      auth_cookie_timeout: "30",
      "tfa-enabled": "true",
    },
  },
  {
    domainName: "direct.sdhealthlink.net",
    data: {
      "data-domain-name": "",
      layout_title: "South Dakota HealthLink Direct Messaging",
      layout_subpage_title: "- SD HealthLink - Direct Mail",
    },
  },
  {
    domainName: "direct.simplyhie.com",
    data: {
      "data-domain-name": "",
      layout_title: "Simply Connect HIE Direct Messaging",
      layout_subpage_title: "- Simply Connect HIE - Direct Mail",
    },
  },
  {
    domainName: "direct.summit-healthcare.org",
    data: {
      "data-domain-name": "",
      layout_title: "Summit Healthcare Direct Messaging",
      layout_subpage_title: "- Summit Healthcare - Direct Mail",
    },
  },
  {
    domainName: "direct.wvhin.org",
    data: {
      "data-domain-name": "",
      layout_title: "WVHIN Direct Messaging",
      layout_subpage_title: "- WVHIN - Direct Mail",
      auth_cookie_timeout: "30",
      "tfa-enabled": "true",
    },
  },
  {
    domainName: "directaddress.net",
    data: {
      "data-domain-name": "",
      layout_title: "DirectAddress  Direct Messaging",
      layout_subpage_title: "- DirectAddress - Direct Mail",
    },
  },
  {
    domainName: "direct-address.net",
    data: {
      "data-domain-name": "",
      layout_title: "Direct-Address Direct Messaging",
      layout_subpage_title: "- Direct-Address - Direct Mail",
    },
  },
  {
    domainName: "direct-address.org",
    data: {
      "data-domain-name": "",
      layout_title: "Direct-Address Direct Messaging",
      layout_subpage_title: "- Direct-Address - Direct Mail",
    },
  },
  {
    domainName: "docutapdirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "DocuTAP Direct Messaging",
      layout_subpage_title: "- DocTAP - Direct Mail",
    },
  },
  {
    domainName: "econsultdirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "eConsult Direct Messaging",
      layout_subpage_title: "- eConsult - Direct Mail",
    },
  },
  {
    domainName: "ferrycohealth.com",
    data: {
      "data-domain-name": "",
      layout_title: "Ferry County Health Direct Messaging",
      layout_subpage_title: "- FCH - Direct Mail",
    },
  },
  {
    domainName: "humanadirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "Humana Direct Messaging",
      layout_subpage_title: "- Humana - Direct Mail",
      pre_register_login_header_text: "Sign In",
    },
  },
  {
    domainName: "humanapartnerdirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "Humana Partner Direct Messaging",
      layout_subpage_title: "- Humana Partner - Direct Mail",
      pre_register_login_header_text: "Sign In",
    },
  },
  {
    domainName: "mhccaremail.com",
    data: {
      "data-domain-name": "",
      layout_title: "MHC CareMail",
      layout_subpage_title: "- MHC CareMail - Direct Mail",
      "allow-non-direct-mail-access": "true",
    },
  },
  {
    domainName: "michiganhisp.midirect.net",
    data: {
      "data-domain-name": "",
      layout_title: "Great Lakes Health Connect Direct Messaging",
      layout_subpage_title: "- Great Lakes Health Connect - Direct Mail",
    },
  },
  {
    domainName: "xdr.midirect.net",
    data: {
      "data-domain-name": "",
      layout_title: "Great Lakes Health Connect Direct Messaging",
      layout_subpage_title: "- Great Lakes Health Connect - Direct Mail",
    },
  },
  {
    domainName: "watersheddirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "Watershed Health Direct Messaging",
      layout_subpage_title: "-Watershed Health - Direct Mail",
    },
  },

  // No Branding ----------------------------------------------
  {
    domainName: "aetnaondirect.com",
    data: {
      "data-domain-name": "aetnaondirect.com",
      layout_title: "Aetna Direct Messaging",
      layout_subpage_title: "- Aetna - Direct Mail",
    },
  },
  {
    domainName: "cynchealthdsm.org",
    data: {
      "data-domain-name": "cynchealthdsm.org",
      layout_title: "Cync Health Direct Messaging",
      layout_subpage_title: "- Cync Health - Direct Mail",
    },
  },

  {
    domainName: "directmi211.org",
    data: {
      "data-domain-name": "directmi211.org",
      layout_title: "Michigan 211 Direct Messaging",
      layout_subpage_title: "- Michigan 211 - Direct Mail",
    },
  },
  {
    domainName: "dsm.optum.com",
    data: {
      "data-domain-name": "dsm.optum.com",
      layout_title: "DSM Optum Direct Messaging",
      layout_subpage_title: "- DSM Optum - Direct Mail",
    },
  },
  {
    domainName: "direct.acumenmd.com",
    data: {
      "data-domain-name": "direct.acumenmd.com",
      layout_title: "Acumen MD Direct Messaging",
      layout_subpage_title: "- Acumen MD - Direct Mail",
    },
  },
  {
    domainName: "direct.avrmc.org",
    data: {
      "data-domain-name": "direct.avrmc.org",
      layout_title: "AVRMC Direct Messaging",
      layout_subpage_title: "- AVRMC - Direct Mail",
    },
  },
  {
    domainName: "direct.bcbsal.org",
    data: {
      "data-domain-name": "direct.bcbsal.org",
      layout_title: "BCBSAL Direct Messaging",
      layout_subpage_title: "- BCBSAL - Direct Mail",
    },
  },
  {
    domainName: "direct.linc2engage.com",
    data: {
      "data-domain-name": "direct.linc2engage.com",
      layout_title: "Linc 2 Engage Direct Messaging",
      layout_subpage_title: "- Linc 2 Engage - Direct Mail",
    },
  },
  {
    domainName: "direct.cdr.onehealthport.com",
    data: {
      "data-domain-name": "direct.cdr.onehealthport.com",
      layout_title: "One Direct Messaging",
      layout_subpage_title: "- One Direct - Direct Mail",
    },
  },
  {
    domainName: "direct.ccspathways.com",
    data: {
      "data-domain-name": "direct.ccspathways.com",
      layout_title: "CCS Pathways Direct Messaging",
      layout_subpage_title: "- CCS Pathways - Direct Mail",
    },
  },
  {
    domainName: "direct.ernesthealth.com",
    data: {
      "data-domain-name": "direct.ernesthealth.com",
      layout_title: "Vibra Healthcare Direct Messaging",
      layout_subpage_title: "- Vibra Healthcare - Direct Mail",
    },
  },
  {
    domainName: "direct.vibrahealth.com",
    data: {
      "data-domain-name": "direct.vibrahealth.com",
      layout_title: "Vibra Healthcare Direct Messaging",
      layout_subpage_title: "- Vibra Healthcare - Direct Mail",
    },
  },
  {
    domainName: "direct.eyecare-partners.com",
    data: {
      "data-domain-name": "direct.eyecare-partners.com",
      layout_title: "Eyecare Partners Direct Messaging",
      layout_subpage_title: "- Eyecare Partners - Direct Mail",
    },
  },
  {
    domainName: "direct.fibroblast.com",
    data: {
      "data-domain-name": "direct.fibroblast.com",
      layout_title: "Fibroblast Direct Messaging",
      layout_subpage_title: "- Fibroblast - Direct Mail",
    },
  },
  {
    domainName: "direct.genesishcc.com",
    data: {
      "data-domain-name": "direct.genesishcc.com",
      layout_title: "Genesis HCC Direct Messaging",
      layout_subpage_title: "- Genesis HCC - Direct Mail",
    },
  },
  {
    domainName: "direct.healthy.io",
    data: {
      "data-domain-name": "direct.healthy.io",
      layout_title: "HealthyIO Direct Messaging",
      layout_subpage_title: "- HealthyIO - Direct Mail",
    },
  },
  {
    domainName: "test.direct.healthy.io",
    data: {
      "data-domain-name": "test.direct.healthy.io",
      layout_title: "HealthyIO Direct Messaging",
      layout_subpage_title: "- HealthyIO - Direct Mail",
    },
  },
  {
    domainName: "direct.interimhealthcarenola.com",
    data: {
      "data-domain-name": "direct.interimhealthcarenola.com",
      layout_title: "Interim Healthcare Nola Direct Messaging",
      layout_subpage_title: "- Interim Healthcare Nola - Direct Mail",
    },
  },
  {
    domainName: "direct-exchange-interbitdata.com",
    data: {
      "data-domain-name": "direct-exchange-interbitdata.com",
      layout_title: "Interbit Data Direct Messaging",
      layout_subpage_title: "- Interbit Data - Direct Mail",
    },
  },
  {
    domainName: "direct.leadingreach.com",
    data: {
      "data-domain-name": "direct.leadingreach.com",
      layout_title: "Leading Reach Direct Messaging",
      layout_subpage_title: "- Leading Reach - Direct Mail",
    },
  },
  {
    domainName: "direct.medtrio.net",
    data: {
      "data-domain-name": "direct.medtrio.net",
      layout_title: "MedTrio Direct Messaging",
      layout_subpage_title: "- MedTrio - Direct Mail",
    },
  },
  {
    domainName: "direct.mrocorp.com",
    data: {
      "data-domain-name": "direct.mrocorp.com",
      layout_title: "MRO Corp Direct Messaging",
      layout_subpage_title: "- MRO Corp - Direct Mail",
    },
  },
  {
    domainName: "direct.ncstep.org",
    data: {
      "data-domain-name": "direct.ncstep.org",
      layout_title: "NCSTEP Direct Messaging",
      layout_subpage_title: "- NCSTEP - Direct Mail",
    },
  },
  {
    domainName: "direct.nuehealthtech.com",
    data: {
      "data-domain-name": "direct.nuehealthtech.com",
      layout_title: "NueHealthTech Direct Messaging",
      layout_subpage_title: "- NueHealthTech - Direct Mail",
    },
  },
  {
    domainName: "direct.oncologicopr.org",
    data: {
      "data-domain-name": "direct.oncologicopr.org",
      layout_title: "Hospital Oncologico Direct Messaging",
      layout_subpage_title: "- Hospital Oncologico - Direct Mail",
    },
  },
  {
    domainName: "direct.optumanalytics.net",
    data: {
      "data-domain-name": "direct.optumanalytics.net",
      layout_title: "Optum Analytics Direct Messaging",
      layout_subpage_title: "- Optum Analytics - Direct Mail",
    },
  },
  {
    domainName: "direct.palmettogba.com",
    data: {
      "data-domain-name": "direct.palmettogba.com",
      layout_title: "Palmetto GBA Direct Messaging",
      layout_subpage_title: "- Palmetto GBA - Direct Mail",
    },
  },
  {
    domainName: "direct.rrhio.org",
    data: {
      "data-domain-name": "direct.rrhio.org",
      layout_title: "RRHIO  Direct Messaging",
      layout_subpage_title: "- RRHIO  - Direct Mail",
      acr_values: "idp:rrhio",
    },
  },
  {
    domainName: "direct.revolutionehr.com",
    data: {
      "data-domain-name": "direct.revolutionehr.com",
      layout_title: "Revolution EHR Direct Messaging",
      layout_subpage_title: "Revolution EHR - Direct Mail",
    },
  },
  {
    domainName: "direct.spearehospital.com",
    data: {
      "data-domain-name": "direct.spearehospital.com",
      layout_title: "Speare Memorial Hospital",
      layout_subpage_title: "- Speare Memorial Hospital - Direct Mail",
    },
  },
  {
    domainName: "direct.umcsn.com",
    data: {
      "data-domain-name": "direct.umcsn.com",
      layout_title: "UMCSN Direct Messaging",
      layout_subpage_title: "- UMCSN - Direct Mail",
    },
  },
  {
    domainName: "dsm.uhc.com",
    data: {
      "data-domain-name": "dsm.uhc.com",
      layout_title: "UHC Direct Messaging",
      layout_subpage_title: "- UHC - Direct Mail",
    },
  },
  {
    domainName: "direct.wishin.org",
    data: {
      "data-domain-name": "direct.wishin.org",
      layout_title: "WishIn Direct Messaging",
      layout_subpage_title: "- WishIn - Direct Mail",
    },
  },

  {
    domainName: "direct.zengemini.net",
    data: {
      "data-domain-name": "direct.zengemini.net",
      layout_title: "Zengemini Direct Messaging",
      layout_subpage_title: "- Zengemini - Direct Mail",
    },
  },

  {
    domainName: "exeterhospitaldirect.com",
    data: {
      "data-domain-name": "exeterhospitaldirect.com",
      layout_title: "Exeter Hospital Direct Messaging",
      layout_subpage_title: "- Exeter Hospital - Direct Mail",
    },
  },
  {
    domainName: "gbmcdirect.org",
    data: {
      "data-domain-name": "gbmcdirect.org",
      layout_title: "GBMC Direct Messaging",
      layout_subpage_title: "- GBMC - Direct Mail",
    },
  },
  {
    domainName: "gohealthdirect.org",
    data: {
      "data-domain-name": "gohealthdirect.org",
      layout_title: "CREOKS Direct Messaging",
      layout_subpage_title: "- CREOKS - Direct Mail",
    },
  },
  {
    domainName: "healthiealerts.org",
    data: {
      "data-domain-name": "healthiealerts.org",
      layout_title: "HealthieGA Direct Messaging",
      layout_subpage_title: "- HealthieGA - Direct Mail",
    },
  },
  {
    domainName: "insyncdirect.com",
    data: {
      "data-domain-name": "insyncdirect.com",
      layout_title: "Insync Direct Messaging",
      layout_subpage_title: "- Insync - Direct Mail",
    },
  },
  {
    domainName: "interface-01.kno2fy.com",
    data: {
      "data-domain-name": "interface-01.kno2fy.com",
      layout_title: "Kno2 Direct Messaging",
      layout_subpage_title: "- Kno2 - Direct Mail",
    },
  },
  {
    domainName: "matrixcaredirect.com",
    data: {
      "data-domain-name": "matrixcaredirect.com",
      layout_title: "MatrixCare Direct Messaging",
      layout_subpage_title: "- MatrixCare - Direct Mail",
    },
  },
  {
    domainName: "mail.medyear.com",
    data: {
      "data-domain-name": "mail.medyear.com",
      layout_title: "Medyear Direct Messaging",
      layout_subpage_title: "- Medyear- Direct Mail",
    },
  },
  {
    domainName: "direct.natera.com",
    data: {
      "data-domain-name": "direct.natera.com",
      layout_title: "Natera Direct Messaging",
      layout_subpage_title: "- Natera - Direct Mail",
    },
  },
  {
    domainName: "optumhiedirect.com",
    data: {
      "data-domain-name": "optumhiedirect.com",
      layout_title: "Optum HIE Direct Messaging",
      layout_subpage_title: "- Optum HIE - Direct Mail",
    },
  },
  {
    domainName: "pennstatetelehealthdirect.org",
    data: {
      "data-domain-name": "",
      layout_title: "Penn State Hershey HIE",
      layout_subpage_title: "- Penn State Hershey HIE - Direct Mail",
    },
  },
  {
    domainName: "ppdxdirect.com",
    data: {
      "data-domain-name": "ppdxdirect.com",
      layout_title: "PPDX Direct Messaging",
      layout_subpage_title: "- PPDX - Direct Mail",
    },
  },
  {
    domainName: "securechartupload.com",
    data: {
      "data-domain-name": "securechartupload.com",
      layout_title: "Secure Chart  Direct Messaging",
      layout_subpage_title: "- Secure Chart - Direct Mail",
    },
  },
  {
    domainName: "securechartupload.net",
    data: {
      "data-domain-name": "securechartupload.net",
      layout_title: "Secure Chart  Direct Messaging",
      layout_subpage_title: "- Secure Chart - Direct Mail",
    },
  },
  {
    domainName: "transact.rrhio.org",
    data: {
      "data-domain-name": "transact.rrhio.org",
      layout_title: "RRHIO Transact Direct Messaging",
      layout_subpage_title: "- RRHIO Transact - Direct Mail",
    },
  },
  {
    domainName: "schospdirect.org",
    data: {
      "data-domain-name": "",
      layout_title: "Swedish Covenant Hospital Direct Messaging",
      layout_subpage_title: "- Swedish Covenant Hospital - Direct Mail",
    },
  },
  {
    domainName: "securegosimerhealth.com",
    data: {
      "data-domain-name": "securegosimerhealth.com",
      layout_title: "SaasEIM Direct Messaging",
      layout_subpage_title: "- SaasEIM - Direct Mail",
    },
  },
  {
    domainName: "test.direct.horizonblue.com",
    data: {
      "data-domain-name": "test.direct.horizonblue.com",
      layout_title: "Horizon Blue Direct Messaging",
      layout_subpage_title: "- Horizon Blue - Direct Mail",
    },
  },
  {
    domainName: "direct.horizonblue.com",
    data: {
      "data-domain-name": "direct.horizonblue.com",
      layout_title: "Horizon Blue Direct Messaging",
      layout_subpage_title: "- Horizon Blue - Direct Mail",
    },
  },
  {
    domainName: "upmcdirect.com",
    data: {
      "data-domain-name": "upmcdirect.com",
      layout_title: "UPMC Direct Messaging",
      layout_subpage_title: "- UPMC - Direct Mail",
    },
  },
  {
    domainName: "uprisedirect.com",
    data: {
      "data-domain-name": "",
      layout_title: "Uprise Direct Messaging",
      layout_subpage_title: "- Uprise - Direct Mail",
    },
  },
  {
    domainName: "ccxsecureexchange.com",
    data: {
      "data-domain-name": "ccxsecureexchange.com",
      layout_title: "Care Centrix Direct Messaging",
      layout_subpage_title: "- Care Centrix - Direct Mail",
    },
  },
  {
    domainName: "direct.abilitynetwork.com",
    data: {
      "data-domain-name": "direct.abilitynetwork.com",
      layout_title: "Ability Network Direct Messaging",
      layout_subpage_title: "- Ability Network - Direct Mail",
    },
  },
  {
    domainName: "direct.acumenmd.com",
    data: {
      "data-domain-name": "direct.acumenmd.com",
      layout_title: "Acumen MD Direct Messaging",
      layout_subpage_title: "- Acumen MD - Direct Mail",
    },
  },
  {
    domainName: "yourcarecommunity.org",
    data: {
      "data-domain-name": "yourcarecommunity.org",
      layout_title: "Your Care Community Direct Messaging",
      layout_subpage_title: "- Your Care Community - Direct Mail",
    },
  },
  {
    domainName: "direct.confermed.com",
    data: {
      "data-domain-name": "",
      layout_title: "direct.confermed.com",
      layout_subpage_title: "- direct.confermed.com",
      auth_cookie_timeout: "30",
      "tfa-enabled": "true",
    },
  },
];
